import React from 'react';
import Form from '../../molecules/Form';
const OutOfStock = ({ testId = 'store-out-of-stock', children, ...otherProps }) => {
    return (React.createElement("section", { "data-store-out-of-stock": true, "data-testid": testId },
        React.createElement(Form, Object.assign({ "data-out-of-stock-form": true, testId: `${testId}-form` }, otherProps), children)));
};
export default OutOfStock;
//# sourceMappingURL=OutOfStock.js.map